<template>
  <div>
    <div class="contact-box-item" @mouseover="isContactUsHover=true" @mouseout="isContactUsHover=false" @click="openDialog">
      <img :src="isContactUsHover?contactUsHover:contactUs"  style="width: 30px;height: 30px;margin-top: 7px;color: white;"/>
      <div style="margin-left: 6px;">联系代购|担保</div>
    </div>
    <el-dialog
        title="联系代购|担保"
        :visible.sync="dialogVisible"
        width="30%"
        >
        <p class="rules" style="color: red;text-align: center;">网站试运行阶段，所有交易均不收手续费</p>
        <p class="rules">1、本公司只负责代为购买，不生产、销售以及回收游戏道具与游戏货币，所购游戏道具或者游戏货币来自可信玩家手中，而非官网渠道购买，请用户知悉</p>
        <p class="rules">2、目前售卖比例为1(元):31.5，最低交易金额10元，如果交易过程中出现小数，将会舍弃小数部分，例如购买11块钱，11*31.5=346.5，舍弃小数部分，仅交易346，部分区服不适用该比例，需按照实际情况决定</p>
        <!-- <p class="rules">3、账号担保交易，交易额不足100元，按最低标准收3元佣金，交易额超过100元部分，按3%比例收取，交易额20万元以内最高收取金额不超过500元，交易额超过20万，按照1000元收取佣金，佣金由卖方支付</p> -->
        <p class="rules">3、账号出租，本公司仅负责保存相应的聊天记录与租号合约，并按照合约保存押金与支付租金，具体政策，请查看平台协议，本公司会按照合同中的月租金，按月收取月租金的1%作为佣金，不足一月按一个月算，当月收取佣金最高不超过300元，该佣金由卖方支付</p>
        <h1>微信扫码或手机号添加微信</h1>
        <h2 class="dialog">微信扫码:</h2>
        <img :src="serviceQR" style="width: 292px;height: 300px;">
        <h2 class="dialog">或者微信添加联系人:13478460876</h2>
      </el-dialog>
  </div>
</template>

<script>
import contactUs from '@/assets/styles/contactuswhite.svg'
import contactUsHover from '@/assets/styles/contactus.svg'
import serviceQR from '@/assets/serviceQR.png'
export default {
  name: 'CallAgent',
  data () {
    return {
      contactUs,
      contactUsHover,
      isContactUsHover: false,
      dialogVisible: false,
      serviceQR
    }
  },
  methods: {
    openDialog () {
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped lang="less">
.dialog{
  margin: 20px auto;
}
.rules{
  text-align: left;
}
.contact-box-item{
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border: 1px solid rgb(168, 168, 168);
  border-radius: 15px;
  width: 150px;
  height: 47px;
  margin: 0 auto;
  font-size: 15px;
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(20rpx);
}
.contact-box-item:hover{
  color: #24a2e6;
  background: rgba(0, 0, 0, 0.0);
  backdrop-filter: blur(10rpx);
}
</style>
